import React from 'react';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { Provider } from 'react-redux';
import ErrorBoundary from './components/errorBoudary';
import createHistory from 'history/createBrowserHistory';

import { QueryClient, QueryClientProvider } from 'react-query';
import { GoogleOAuthProvider } from '@react-oauth/google';

import moment from 'moment';
const history = createHistory();

import './i18n';
import Routes from './routes';
import { store } from './store/store';
import { Toaster } from '@/components/ui/Toaster';

const persistor = persistStore(store);

const queryClient = new QueryClient();

moment.locale('cs');

const App: React.FC = () => (
  <Provider store={store}>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <QueryClientProvider client={queryClient}>
        <PersistGate loading={null} persistor={persistor}>
          <ErrorBoundary>
            <Routes history={history} />
            <Toaster />
          </ErrorBoundary>
        </PersistGate>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  </Provider>
);

export default App;
